import {
  Component,
  OnDestroy,
  Inject,
  OnInit,
  ViewChild,
  ElementRef,
} from '@angular/core';
import {
  SuiModal,
  SuiModalService,
  ComponentModalConfig,
  ModalSize,
  DatepickerMode,
} from '@richardlt/ng2-semantic-ui';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { forkJoin, of } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { CompanyService, DocumentService } from '../../services';
import { AuthenticationService } from 'src/modules/core/services';
import { OrganizationService } from 'src/modules/features/contractor/services';
import { CompanyOwnershipService } from '@app/shared/services/company-ownership.service';
import { environment } from 'src/environments/environment';
import { AolService } from '../../services/aol';
import { type } from 'os';
import { LinkDocumentModal } from '../link-document-type-modal/link-document-type-modal.component';
import { ActivatedRoute } from '@angular/router';
import { AppFilter } from '@app/shared/models';
import { EditSharesModal } from '../edit-shares/edit-shares-component';
import { CommonServices } from '@app/shared/services';

interface INewDirectorModalContext {
  data?: any;
  title?: string;
  isEdit?: boolean;
}
interface Document {
  documentTypeId: string;
  documentTypeName: string;
  isRequired: boolean;
  isActive: boolean;
  dateCreated: string;
  dateModified: string;
  group: any;
  createdBy: string;
  modifiedBy: string;
  uploadedFiles?: File[];
}
@Component({
  selector: 'app-new-personnel-modal',
  templateUrl: './new-individual-modal.component.html',
  styleUrls: ['./new-individual-modal.component.scss'],
})
export class NewIndividualModalComponent implements OnInit, OnDestroy {
  pendingArr: boolean[] = [];
  companyDirectorForm: FormGroup;
  formSubmitAttempt: boolean;
  countries: Array<any> = [];
  typeId: string = 'Individual';
  typeName;
  affiliateTypeId;
  success: any;
  error: any;
  eRadio: any = 'new';
  firstPage: boolean = true;
  secondPage: boolean = false;
  checkbox: boolean = false;
  filter: AppFilter = new AppFilter();
  organizationId: string;
  companyAffiliateTypes!: any[];
  allAffiliateTypes!: any[];
  selectedFilePhoto: File | null = null;
  fileNamePhoto: string = '';
  imageUrl: string | ArrayBuffer | null = '';
  companyType = JSON.parse(window.localStorage.getItem('user')).organizationId
    .jpaContractor?.companyType?.optionId;
  companyDirectors: any[] = [];
  baseUrl = environment.API_SERVER;
  uploadFormData: any;
  replyForm: FormGroup;
  resultToBeAdded;
  typeStructure;
  organization;
  companyDirector;
  shareHoldingAmount;
  usePercentage: boolean = false;
  showCapital: boolean = false;
  secondExistingPage: boolean = false;
  previousDirector;

  isBtnDisabled: boolean = true;

  supportingDocumentError: string = '';
  supportingDocuments: File[] = [];
  documents:
    | {
        documentId: string;
        documentPath: string;
      }[]
    | null[] = [null, null];

  meansOfIdentifications: any[] = [];
  constructor(
    private companySvc: CompanyService,
    private modalService: SuiModalService,
    @Inject(DOCUMENT) private document,
    private fb: FormBuilder,
    public modal: SuiModal<INewDirectorModalContext, void, void>,
    private documentSvc: DocumentService,
    private companyOwnershipService: CompanyOwnershipService,
    private AolService: AolService,
    private commonService: CommonServices
  ) {
    this.countries = this.modal.context.data.countries;
    this.previousDirector = this.modal.context.data.previoudDirector;
    this.typeStructure = this.modal.context.data.item;
    this.usePercentage = this.modal.context.data?.usePercentage;
    this.affiliateTypeId = this.modal.context.data.affiliateTypeId;
    this.shareHoldingAmount =
      this.modal.context.data.shareHoldingAmount.totalShareCapital;
    this.typeName = this.modal.context.data.affiliateTypeName;
    this.organization = JSON.parse(window.localStorage.getItem('user'));
    this.organizationId = window.localStorage.getItem('organizationId');
    this.filter = new AppFilter({ sidx: 'dateCreated', rows: 100 });

    this.companyDirectorForm = fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      address: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phoneNumber: ['', [Validators.required]],
      middleName: [''],
      shareholderType: [''],
      companyName: [''],
      companyRegNumber: [''],
      gender: ['', Validators.required],
      nationalityId: ['', Validators.required],
      countryOfOriginId: ['', Validators.required],
      nationalIdNumber: [''],
      companyEmail: [null],
      businessInformationProviderId: [null],
      businessInformationProvider: [null],
      organizationOwnershipTypeId: [''],
      organizationOwnershipId: [''],
      shareholding: [0, Validators.required],
      actionType: [''],
      shareCapital: [this.shareHoldingAmount],
      shareAllocated: [''],
      meansOfIdentificationId: [''],
      identificationNumber: [''],
      identificationDocument1Id: [''],
      identificationDocument1Path: [''],
      identificationDocument2Id: [''],
      identificationDocument2Path: [''],
      photographDocumentId: [''],
      photographDocumentPath: [''],
    });
    this.replyForm = fb.group({
      documentTypeId: ['CHANGE_REQUEST_DOCUMENT', Validators.required],
      documentName: ['PROFILE_PHOTO', Validators.required],
      document: ['', Validators.required],
      attachment: [true],
      documentDescription: ['string'],
    });
    if (this.modal.context.isEdit) {
      this.secondPage = true;
      this.firstPage = false;
      this.companyDirector = modal.context.data.director;

      if (this.companyDirector.identificationDocument1Id) {
        this.documents[0] = {
          documentId: this.companyDirector.identificationDocument1Id,
          documentPath: this.companyDirector.identificationDocument1Path,
        };
      }

      if (this.companyDirector.identificationDocument2Id) {
        this.documents[1] = {
          documentId: this.companyDirector.identificationDocument2Id,
          documentPath: this.companyDirector.identificationDocument2Path,
        };
      }

      this.companyDirectorForm.patchValue(this.companyDirector);

      this.companyDirectorForm
        .get('shareAllocated')
        .setValue(
          (modal.context.data.director.shareholding / 100) *
            modal.context.data.shareHoldingAmount.totalShareCapital
        );
    }
    this.companyDirectorForm
      .get('shareAllocated')
      .valueChanges.subscribe((value) => {
        const sharePercentage = (value / this.shareHoldingAmount) * 100;

        if (sharePercentage > 100) {
          this.error = 'Share percentage cannot be greater than 100';
          // set company director error
          this.companyDirectorForm.get('shareholding').setErrors({
            invalid: true,
          });
          return;
        }

        if (
          sharePercentage +
            (this.modal.context.data?.totalUsedSharesPercentage /
              this.shareHoldingAmount) *
              100 >
          100
        ) {
          this.error =
            'Share percentage cannot be greater than Total Share Capital';
          // set company director error
          this.companyDirectorForm.get('shareholding').setErrors({
            invalid: true,
          });
          return;
        }
        this.calculateShareholding(value);
      });
    this.companyDirectorForm
      .get('shareCapital')
      .valueChanges.subscribe((value) => {
        this.calculateShareholding(value);
      });

    this.getMeansOfIdentification();
  }

  checkBtnDisabled() {
    if (this.pendingArr?.length) {
      this.isBtnDisabled = true;
      return;
    }

    if (this.modal.context.isEdit) {
      this.isBtnDisabled = false;
      return;
    }

    if (!this.secondPage) {
      this.isBtnDisabled = false;
      return;
    }

    if (
      this.secondPage &&
      this.eRadio === 'new' &&
      !this.companyDirectorForm.valid
    ) {
      this.isBtnDisabled = true;
      return;
    }

    if (
      this.secondPage &&
      this.eRadio === 'new' &&
      (!this.selectedFilePhoto || !this.supportingDocuments.length)
    ) {
      this.isBtnDisabled = true;
      return;
    }

    this.isBtnDisabled = false;
  }
  getMeansOfIdentificationText() {
    return `${
      this.meansOfIdentifications.find(
        (item) =>
          item.optionId ===
          this.companyDirectorForm.get('meansOfIdentificationId').value
      )?.optionName
    } (Photo of a slip, ID Card, front and back)`;
  }

  getMeansOfIdentification() {
    this.callStarted();
    this.commonService
      .getOption({
        params: new AppFilter({
          _search: true,
          rows: 100,
          filters: JSON.stringify({
            groupOp: 'AND',
            rules: [
              {
                field: 'optionType.optionTypeId',
                op: 'eq',
                data: 'identification_means',
              },
            ],
          }),
        }),
      })
      .subscribe(
        (res: any) => {
          this.meansOfIdentifications = res.rows;
          // console.log(res);
          this.callCompleted();
        },
        () => {
          this.callCompleted();
          this.error = 'Error while fetching company types';
        }
      );
  }

  calculateShareholding(shareAllocated: string) {
    const numericShareAllocated = parseFloat(shareAllocated.replace(/,/g, ''));
    if (numericShareAllocated && this.shareHoldingAmount) {
      const shareholding =
        (numericShareAllocated / this.shareHoldingAmount) * 100;
      this.companyDirectorForm.get('shareholding').setValue(shareholding);
    } else {
      this.companyDirectorForm.get('shareholding').setValue(0);
    }
  }
  editShares() {
    this.modalService
      .open(
        new EditSharesModal(
          'Edit Total Share Capital',
          this.shareHoldingAmount,
          ModalSize.Mini
        )
      )
      .onApprove((payload) => {
        this.shareHoldingAmount = payload;
        this.companyDirectorForm.get('shareCapital').setValue(payload);
      })
      .onDeny(() => {});
  }
  onFileChangeData(event) {
    const files = event.target.files;
    if (!files) {
      return;
    }
    if (this.isFileTypeAllowed(files[0])) {
      this.selectedFilePhoto = files[0];
      this.fileNamePhoto = this.selectedFilePhoto['name'];
      this.previewImage(this.selectedFilePhoto);
      this.checkBtnDisabled();
    } else {
      this.error =
        'Invalid file type. Please select a .jpg, .jpeg, or .png file.';
      return;
    }
  }
  getDocumentPath(data) {
    this.callStarted();
    this.AolService.getDocument({ documentId: data }).subscribe(
      (res: any) => {
        this.callCompleted();
        this.fileNamePhoto = res.documentPath.split('______')[1];
        this.imageUrl = `${this.baseUrl}/public/image/?media=${res.documentPath}`;
      },
      (error) => {
        this.callCompleted();
        this.error = error.error;
      }
    );
  }
  isFileTypeAllowed(file: File): boolean {
    const allowedTypes = ['.jpg', '.jpeg', '.png'];
    const fileType = '.' + file.name.split('.').pop();
    return allowedTypes.includes(fileType.toLowerCase());
  }
  previewImage(file: File) {
    const reader = new FileReader();
    reader.onload = (e) => {
      this.imageUrl = e.target?.result;
    };
    reader.readAsDataURL(file);
  }
  ngOnInit() {
    this.checkBtnDisabled();
    // this.document.body.classList.remove('panel');
    this.getAffiliateTypes(this.companyType);
    this.companyDirectorForm.valueChanges.subscribe(() => {
      this.checkBtnDisabled();
    });

    this.companyDirectorForm
      .get('phoneNumber')
      .valueChanges.subscribe((value) => {
        if (value) {
          const numericValue = value.replace(/[^0-9]/g, '');
          if (numericValue !== value) {
            this.companyDirectorForm
              .get('phoneNumber')
              .setValue(numericValue, { emitEvent: false });
          }
        }
      });
  }
  getAffiliateTypes(companyTypeId: string) {
    if (companyTypeId === 'public_company_limited_by_shares_actual') {
      companyTypeId = 'limited_liability';
    }

    this.callStarted();
    this.companyOwnershipService
      .getOwnershipsForCompanyType({ companyTypeId })
      .pipe(
        tap((companyAffiliateTypes: any) => {
          this.companyAffiliateTypes = companyAffiliateTypes;
        }),
        switchMap(() =>
          forkJoin({
            allAffiliateTypes: this.companyOwnershipService.getOwnershipTypes(),
          })
        )
      )
      .subscribe(
        (res: any) => {
          this.callCompleted();
          this.allAffiliateTypes = res?.allAffiliateTypes;

          this.companyAffiliateTypes.forEach((c) => {
            const match = res?.allAffiliateTypes.find(
              (a) => a.optionName === c.ownershipType
            );
            if (match) {
              c.ownershipTypeId = match.optionId;
            }
          });

          this.companyAffiliateTypes = this.companyAffiliateTypes.filter(
            (c) => c.ownershipTypeId !== this.affiliateTypeId
          );

          this.companyAffiliateTypes?.forEach((c) =>
            this.getPage(1, c.ownershipTypeId)
          );
        },
        (err) => {
          this.callCompleted();
        }
      );
  }

  getPage(page, ownershipType) {
    this.filter.page = page;
    this.callStarted();
    this.companySvc
      .getCompanyDirector({
        organizationId: this.organizationId,
        ownershipType: ownershipType,
        params: this.filter,
      })
      .subscribe(
        (res: any) => {
          this.callCompleted();
          const directorExists = (newDirector, existingDirectors) => {
            if (!existingDirectors || !Array.isArray(existingDirectors)) {
              return false;
            }

            return existingDirectors.some(
              (director) =>
                director.firstName === newDirector.firstName &&
                director.lastName === newDirector.lastName
            );
          };
          const newCheckDirectors = res.rows.filter(
            (newDirector) => !directorExists(newDirector, this.companyDirectors)
          );
          const newDirectors = newCheckDirectors.filter(
            (newDirector) => !directorExists(newDirector, this.previousDirector)
          );
          this.companyDirectors = this.companyDirectors.concat(newDirectors);
          if (
            this.modal.context.isEdit &&
            this.modal.context.data.director.photographDocumentId
          ) {
            this.getDocumentPath(
              this.modal.context.data.director.photographDocumentId
            );
          }
        },
        (error) => {
          this.callCompleted();
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error
            ? error.error
            : error;
        }
      );
  }
  ngOnDestroy(): void {
    // this.document.body.classList.add('panel');
  }
  submit() {
    if (
      this.eRadio === 'existing' &&
      !this.secondPage &&
      this.affiliateTypeId === 'shareholder_type' &&
      !this.secondExistingPage
    ) {
      this.secondExistingPage = true;
      return;
    }
    if (
      this.eRadio === 'existing' &&
      !this.secondPage &&
      this.affiliateTypeId === 'shareholder_type' &&
      this.secondExistingPage
    ) {
      if (!this.usePercentage && this.affiliateTypeId === 'shareholder_type') {
        if (
          this.shareHoldingAmount <
            Number(this.companyDirectorForm.value.shareAllocated) ||
          this.shareHoldingAmount === 0 ||
          Number(this.companyDirectorForm.value.shareholding) > 100
        ) {
          this.showCapital = true;
          return;
        }
      }
      this.submitExistingShareholder();
      return;
    }
    if (
      this.eRadio === 'existing' &&
      !this.secondPage &&
      this.affiliateTypeId !== 'shareholder_type'
    ) {
      this.existingSubmission();
    }
    if (this.eRadio === 'new' && this.firstPage && !this.secondPage) {
      this.secondPage = true;
      this.firstPage = false;
      this.checkBtnDisabled();
      return;
    }
    if (this.eRadio === 'new' && this.secondPage && !this.firstPage) {
      if (!this.usePercentage && this.affiliateTypeId === 'shareholder_type') {
        if (
          this.shareHoldingAmount <
            Number(this.companyDirectorForm.value.shareAllocated) ||
          this.shareHoldingAmount === 0 ||
          Number(this.companyDirectorForm.value.shareholding) > 100
        ) {
          this.showCapital = true;
          return;
        }
      }
      // console.log(this.companyDirectorForm.value, 'form');
      if (this.companyDirectorForm.valid) {
        this.newSubmission();
      } else {
        this.error = 'Please fill all required fields';
      }
      return;
    }
  }
  async newSubmission() {
    if (this.selectedFilePhoto) {
      if (this.selectedFilePhoto && !this.getFileSizePhotograph(this.selectedFilePhoto.size)) {
        this.error = `File (${this.selectedFilePhoto.name}) size is too large, Maximum file size is 1MB`;
        return;
      }

      this.callStarted();

      await this.uploadDocuments();
      this.saveAction();
    } else if ((this.modal.context.isEdit && this, this.imageUrl)) {
      this.callStarted();
      if (this.selectedFilePhoto || this.supportingDocuments.length > 0) {
        await this.uploadDocuments();
      }
      this.saveAction();
    } else {
      this.error = `Please Upload a Profile Photo`;
      return;
    }
  }

  showSupportingDocuments() {
    if (!this.companyDirectorForm.get('nationalityId').value) return false;
    if (this.companyDirectorForm.get('nationalityId').value === 'NG')
      return true;
    if (this.companyDirectorForm.get('meansOfIdentificationId').value)
      return true;
    return false;
  }

  uploadDocuments(): Promise<void> {
    return new Promise((resolve, reject) => {
      // Create an array to store all upload promises
      const uploadPromises: Promise<void>[] = [];

      if (this.selectedFilePhoto) {
        // Upload profile photo
        const profilePhotoPromise = new Promise<void>(
          (resolvePhoto, rejectPhoto) => {
            let data: any = this.replyForm.value;
            const formData: FormData = new FormData();
            formData.append(
              'file',
              this.selectedFilePhoto,
              this.selectedFilePhoto.name
            );
            let payload: any = { formValue: data, formData: formData };
            this.uploadFormData = payload['formData'];
            const values = payload['formValue'];
            const jsonse = JSON.stringify(values);
            const blob = new Blob([jsonse], { type: 'application/json' });
            this.uploadFormData.append('data', blob);

            // Convert onUploadFilePhoto to return a Promise
            this.documentSvc
              .uploadDocument({
                organizationId: this.organizationId,
                body: this.uploadFormData,
              })

              .subscribe(
                (result: any) => {
                  this.companyDirectorForm.value['photographDocumentId'] =
                    result.documentId || result.photographDocumentId;
                  this.companyDirectorForm.value['photographDocumentPath'] =
                    result.documentPath || result.photographDocumentPath;
                  resolvePhoto();
                },
                (error) => {
                  this.error = 'Error while uploading profile photo';
                  rejectPhoto(error);
                }
              );
          }
        );
        uploadPromises.push(profilePhotoPromise);
      }

      if (this.supportingDocuments.length > 0) {
        // Upload supporting documents
        this.supportingDocuments.forEach((document, index) => {
          const supportingDocPromise = new Promise<void>(
            (resolveDoc, rejectDoc) => {
              let data: any = this.replyForm.value;
              const formData: FormData = new FormData();
              formData.append('file', document, document.name);
              let payload: any = { formValue: data, formData: formData };
              this.uploadFormData = payload['formData'];
              const values = payload['formValue'];
              const jsonse = JSON.stringify(values);
              const blob = new Blob([jsonse], { type: 'application/json' });
              this.uploadFormData.append('data', blob);

              this.documentSvc
                .uploadDocument({
                  organizationId: this.organizationId,
                  body: this.uploadFormData,
                })

                .subscribe(
                  (result: any) => {
                    if (this.modal.context.isEdit) {
                      const documentIndex = this.documents.findIndex(
                        (item) => item === null
                      );
                      this.companyDirectorForm.value[
                        `identificationDocument${documentIndex + 1}Id`
                      ] = result.documentId;
                      this.companyDirectorForm.value[
                        `identificationDocument${documentIndex + 1}Path`
                      ] = result.documentPath;
                      this.documents[documentIndex] = result;
                      this.supportingDocuments =
                        this.supportingDocuments.filter(
                          (item) => item !== document
                        );
                    } else {
                      this.companyDirectorForm.value[
                        `identificationDocument${index + 1}Id`
                      ] = result.documentId;
                      this.companyDirectorForm.value[
                        `identificationDocument${index + 1}Path`
                      ] = result.documentPath;
                    }

                    resolveDoc();
                  },
                  (error) => {
                    this.error = 'Error while uploading supporting document';
                    rejectDoc(error);
                  }
                );
            }
          );
          uploadPromises.push(supportingDocPromise);
        });
      }

      // Wait for all uploads to complete
      Promise.all(uploadPromises)
        .then(() => {
          this.callCompleted();
          resolve();
        })
        .catch((error) => {
          this.callCompleted();
          reject(error);
        });
    });
  }

  getChosenExistingResult() {
    return this.companyDirectors.filter((item) => item.checkbox)[0];
  }
  submitExistingShareholder() {
    this.resultToBeAdded = this.companyDirectors.filter(
      (item) => item.checkbox
    );
    if (this.resultToBeAdded.length > 0) {
      this.resultToBeAdded.map((item) => {
        delete item.organizationOwnershipId;
        item.actionType = 'LINK';
        item.shareholding = this.companyDirectorForm.value.shareholding;
        item.shareCapital = this.companyDirectorForm.value.shareCapital;
        item.shareAllocated = this.companyDirectorForm.value.shareAllocated;
      });
      this.success = `Record ${
        this.modal.context.isEdit ? 'Updated' : 'Added'
      }`;
      setTimeout(() => {
        this.modal.approve(this.resultToBeAdded);
        return;
      }, 3000);
    } else {
      this.error = `Please Select an Existing structure`;
      return;
    }
  }
  existingSubmission() {
    this.resultToBeAdded = this.companyDirectors.filter(
      (item) => item.checkbox
    );
    if (this.resultToBeAdded.length > 0) {
      this.resultToBeAdded.map((item) => {
        item.ownershipTypeIdName = [
          {
            [this.affiliateTypeId]: this.typeName,
          },
        ];
        item.actionType = this.modal.context.isEdit
          ? this.companyDirector.actionType === 'LINK'
            ? 'LINK'
            : 'UPDATE'
          : 'ADD';
      });
      this.success = `Record ${
        this.modal.context.isEdit ? 'Updated' : 'Added'
      }`;
      setTimeout(() => {
        this.modal.approve(this.resultToBeAdded);
        return;
      }, 3000);
    } else {
      this.error = `Please Select an Existing structure`;
      return;
    }
  }
  getFileSize(fileInput: number) {
    const fileSizeBytes = fileInput;
    const fileSizeKB = fileSizeBytes / 1024;
    const fileSizeMB = fileSizeKB / 1024;
    return fileSizeMB;
  }

  getFileSizePhotograph(fileInput: number) {
    const fileSizeMB = this.getFileSize(fileInput);
    if (fileSizeMB > 1) {
      return false;
    } else {
      return true;
    }
  }

  uploadImage($event: File) {
    const fileSizeMB = this.getFileSize($event.size);
    if (fileSizeMB > 1) {
      this.supportingDocumentError =
        'File size is too large, Maximum file size is 1MB';
      return;
    }

    // if (this.companyDirectorForm.get('nationalityId').value === 'NG') {
    //   if (this.modal.context.isEdit) {
    //     this.documents = [null, null];
    //   }

    //   return;
    // }

    if (this.modal.context.isEdit) {
      const allDocuments = [...this.documents, ...this.supportingDocuments];
      if (allDocuments.filter((item) => item !== null).length > 1) {
        this.supportingDocumentError = 'You can only upload 2 documents';
        return;
      }
    }

    if (this.supportingDocuments.length == 2) {
      this.supportingDocumentError = 'You can only upload 2 documents';
      return;
    }

    this.supportingDocumentError = '';
    this.supportingDocuments.push($event);
    this.checkBtnDisabled();
  }

  viewFiles(file: File): void {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      const blob = new Blob([e.target.result], { type: file.type });
      const url = window.URL.createObjectURL(blob);
      window.open(url, '_blank');
    };
    reader.readAsArrayBuffer(file); // Use readAsArrayBuffer for binary data
  }

  viewDocument(document: any): void {
    const url = `${this.baseUrl}/public/image/?media=${document.documentPath}`;
    window.open(url, '_blank');
  }

  removeFile(fileIndex: number): void {
    this.supportingDocuments.splice(fileIndex, 1);
  }

  removeDocument(documentIndex: number): void {
    this.documents[documentIndex] = null;
  }

  saveAction() {
    this.resultToBeAdded = [];

    this.companyDirectorForm.value.actionType = this.modal.context.isEdit
      ? this.companyDirector.actionType === 'LINK'
        ? 'LINK'
        : 'UPDATE'
      : 'ADD';

    (this.companyDirectorForm.value.createdBy = JSON.stringify({
      name: this.organization.firstName + ' ' + this.organization.lastName,
      username: this.organization.username,
      appUserId: this.organization.appUserId,
      organizationId: this.organization.organizationId.organizationId,
      organizationName: this.organization.organizationId.organizationShortName,
    })),
      (this.companyDirectorForm.value.dateCreated = new Date().toISOString()),
      this.resultToBeAdded.push(this.companyDirectorForm.value);
    this.success = `Record ${this.modal.context.isEdit ? 'Updated' : 'Added'}`;
    setTimeout(() => {
      this.modal.approve(this.resultToBeAdded);
      return;
    }, 3000);
  }
  goBack() {
    this.secondPage = false;
    this.firstPage = true;
    this.eRadio = 'new';
  }
  isFieldValid(field: string) {
    return (
      (!this.companyDirectorForm.get(field).valid &&
        this.companyDirectorForm.get(field).touched) ||
      (this.companyDirectorForm.get(field).untouched && this.formSubmitAttempt)
    );
  }
  displayFieldCss(field: string) {
    return {
      error: this.isFieldValid(field),
    };
  }

  displayFormCss(field: string) {
    return {
      loading: field,
    };
  }
  onBoxChecked(selectedDirector: any, isChecked: boolean) {
    if (isChecked) {
      this.companyDirectors.forEach((director) => {
        if (director !== selectedDirector) {
          director.checkbox = false;
        }
      });
    }
    selectedDirector.checkbox = isChecked;
  }
  deleteImage(event: Event) {
    event.stopPropagation();
    this.imageUrl = null;
    this.fileNamePhoto = null;
  }

  callStarted() {
    this.pendingArr.push(true);
    this.checkBtnDisabled();
  }

  callCompleted() {
    this.pendingArr.pop();
    this.checkBtnDisabled();
  }
}

export class NewIndividualModal extends ComponentModalConfig<
  INewDirectorModalContext,
  void,
  void
> {
  constructor(
    title: string,
    data: any,
    isEdit: boolean,
    size: ModalSize = ModalSize.Mini
  ) {
    super(NewIndividualModalComponent, { title, data, isEdit });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
